import * as React from "react";
export const ModalHeader = (props) => {
    return (React.createElement("div", { className: "modal-header", "data-testid": props.testId },
        props.children,
        !!props.toggle &&
            (!!props.close ? (props.close) : (React.createElement("button", { type: "button", className: "close", "aria-label": "Close", onClick: props.toggle },
                React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))))));
};
//# sourceMappingURL=ModalHeader.js.map